// educatndata.js
export const educatndata = [
  {
    year: '2019 - 2022',
    edu: 'Bachelor of Science ',
    clg: 'JSS Arts,Commerce and Shantikumar Gubbi Science College',
    pdfs: '',
  },
  // {
  //   year: '2017 - 2019',
  //   edu: '12th (PUC) — PCME',
  //   // per: '| 75%',
  //   clg: 'Sharada PU College, Karwar',
  //   pdfs: '',
  // },
  // {
  //   year: '2017 - 2018',
  //   edu: '10th (SSLC)',
  //   per: '| 85%',
  //   clg: 'Kendriya Vidyalaya, Karwar',
  //   pdfs: '',
  // },
  {
    year: '2023 - 2023',
    edu: 'Master of Science',
    per: ' ||  AI, ML & Cloud Computing',
    clg: 'Garden City University',
    pdfs: '',
  },
];
